import {
    CHECK_WALLET_STATS,
    EMERALD,
    GREEN,
    ORANGE,
    RED,
    RESULT,
    TOKEN_ANALYZER_STATS,
    TOKEN_AVERAGE_BUY_VOLUME,
    TOKEN_AVERAGE_TRADE_TIME,
    TOKEN_NAME,
    TOKEN_PNL,
    TOKEN_TRADES,
    TOKEN_TRANSACTIONS,
    TOKEN_WALLETS,
    USER_DATA_UPDATED,
    WALLET_AVERAGE_BUY_VOLUME,
    WALLET_AVERAGE_TRADE_TIME,
    WALLET_PNL,
    WALLET_PROFIT,
    WALLET_TRADES,
    WALLET_WIN_RATE,
    YELLOW
} from "../consts/consts";

export function apiRequests() {

    /* Tg authorization */
    async function reqAuth(initData) {
        try {
            // Отправляем запрос на аутентификацию
            const response = await fetch("https://api.investorium.org/auth", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ initData}),
            });

            // Обрабатываем ответ, если не OK
            if (!response.ok) {
                let errorMessage;
                if (response.status === 403) {
                    errorMessage = '403';
                } else if (response.status === 500) {
                    errorMessage = '500';
                } else if (response.status === 404) {
                    errorMessage = '404';
                } else {
                    errorMessage = response.status.toString()
                }
                throw new Error(errorMessage);
            }

            // Парсим успешный ответ
            const dataRaw = await response.json();
            dataRaw.status = USER_DATA_UPDATED;

            // Логирование полученных данных
            return dataRaw;

        } catch (error) {
            // Логирование ошибок
            // Возвращаем ошибку в удобном формате
            throw error;
        }
    }



    /* Tg authorization */
    async function checkTonTx(reqData) {
        try {
            // Отправляем запрос на аутентификацию
            const response = await fetch("https://api.investorium.org/account_upgrade", {
                method: "POST",
                body: JSON.stringify(reqData),
                headers: {
                    "Content-Type": "application/json",
                },
                dataType: 'json'
            });



            // Обрабатываем ответ, если не OK
            if (!response.ok) {
                throw new Error(response.status.toString());
            }

            // Парсим успешный ответ
            const dataRaw = await response.json();
            dataRaw.status = USER_DATA_UPDATED;

            // Логирование полученных данных


            return dataRaw;

        } catch (error) {


            // Возвращаем ошибку в удобном формате
            throw error;
        }
    }


    /* Update user data */
    async function getUserDataFromDb(reqData) {
        try {
            // Отправляем запрос на аутентификацию
            const response = await fetch("https://api.investorium.org/get_user_info_by_user", {
                method: "POST",
                body: JSON.stringify(reqData),
                headers: {
                    "Content-Type": "application/json",
                },
                dataType: 'json'
            });



            // Обрабатываем ответ, если не OK
            if (!response.ok) {
                throw new Error(response.status.toString());
            }

            // Парсим успешный ответ
            const dataRaw = await response.json();
            dataRaw.status = USER_DATA_UPDATED;

            // Логирование полученных данных


            return dataRaw;

        } catch (error) {
            // Возвращаем ошибку в удобном формате
            throw error;
        }
    }





    async function reqCheckWalletOrSetTask(id, token, blockchain, address, task = "None") {
        try {
            const requestData = {
                id: id,
                token: token,
                blockchain: blockchain,
                address: address,
                task: task
            };
            const response = await fetch("https://api.investorium.org/check_wallet", {
                method: "POST",
                body: JSON.stringify(requestData),
                headers: {
                    "Content-Type": "application/json",
                },
                dataType: 'json'
            });
            if (!response.ok) {
                return {
                    "status": "ERROR",
                    "code": response.status
                }

            }

            const dataRaw = await response.text();
            const data = JSON.parse(dataRaw);

            return data
        } catch (error) {
            return {
                "status": "ERROR",
                "code": 550
            }
        }
    }

    async function reqTokenAnalyzerOrSetTask(id, token, blockchain, address, task = "None") {
        try {
            const requestData = {
                id: id,
                token: token,
                blockchain: blockchain,
                address: address,
                task: task
            };

            const response = await fetch("https://api.investorium.org/token_analyzer", {
                method: "POST",
                body: JSON.stringify(requestData),
                headers: {
                    "Content-Type": "application/json",
                },
                dataType: 'json'
            });
            if (!response.ok) {
                return {
                    "status": "ERROR",
                    "code": response.status
                }

            }

            const dataRaw = await response.text();
            const data = JSON.parse(dataRaw);

            return data
        } catch (error) {
            return {
                "status": "ERROR",
                "code": 550
            }
        }
    }

    async function reqCheckWallet(blockchain, addr) {
        try {
            const response = await fetch('https://api.investorium.org/async_check_wallet/'
                + blockchain + "/" + addr);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const dataRaw = await response.text();
            const data = JSON.parse(dataRaw);

            let parsedData = parseCheckWalletResult(data);

            return parsedData;
        } catch (error) {
            console.error(error);
        }
    }

    async function reqTokenAnalyzer(addr) {
        try {
            const response = await fetch('https://api.investorium.org/async_token_analyzer/' + addr);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const dataRaw = await response.text();
            const data = JSON.parse(dataRaw);
            let parsedData = parseTokenAnalyzerResult(data);
            return parsedData;
        } catch (error) {
            console.error(error);
        }
    }

    function parseCheckWalletResult(data) {
        if(data.hasOwnProperty("status")) {
            if(data["status"] === RESULT) {
                let stats, tokens, portfolio, address, shortAddress = null;
                if(data.hasOwnProperty("stats")){
                    stats = parseCheckWalletStats(data["stats"]);
                }
                if(data.hasOwnProperty("tokens")){
                    tokens = parseCheckWalletTokens(data["tokens"]);
                }
                if(data.hasOwnProperty("portfolio")){
                    portfolio = parseCheckWalletPortfolio(data["portfolio"]);
                }
                if(data.hasOwnProperty("address")){
                    address = data["address"];
                    shortAddress = getAddress(data["address"]);
                }

                return {
                    status: CHECK_WALLET_STATS,
                    address: address,
                    shortAddress: shortAddress,
                    walletStats: stats,
                    walletTokens : tokens,
                    walletBalances: portfolio
                }
            }
        }
    }

    function parseTokenAnalyzerResult(data) {
        if(data.hasOwnProperty("status")) {
            if(data["status"] === RESULT) {
                let stats, wallets, address, shortAddress = null;
                if(data.hasOwnProperty("stats")){
                    stats = parseTokenAnalyzerStats(data["stats"]);
                }
                if(data.hasOwnProperty("wallets")){
                    wallets = parseTokenAnalyzerWallets(data["wallets"]);
                }
                if(data.hasOwnProperty("address")){
                    address = data["address"];
                    shortAddress = getAddress(data["address"]);
                }

                return {
                    status: TOKEN_ANALYZER_STATS,
                    address: address,
                    shortAddress: shortAddress,
                    tokenStats: stats,
                    tokenWallets : wallets,
                }
            }
        }
    }
    function parseCheckWalletTokens(tokens) {
        let walletTokens = [];
        for(let i in tokens) {
            walletTokens.push({
                    symbol: getTokenSymbol(tokens[i][0]),
                    name: getTokenName(tokens[i][1]),

                    indicator: getTypeOfIndicatorByValue(WALLET_PNL, tokens[i][6]),

                    short_address: getAddress(tokens[i][2].toLowerCase()),
                    address:tokens[i][2].toLowerCase(),

                    bought: floatNumToString(tokens[i][3]),
                    sold: floatNumToString(tokens[i][4]),

                    profit: floatNumToString(tokens[i][5]),
                    pnl: floatNumToString(tokens[i][6]),

                    firstTx: formatDate(tokens[i][7]),//timeConverter(tokens[i][7]),
                    lastTx: formatDate(tokens[i][8]),

                    tradeTime: getTradeTime(tokens[i][9]),

                    buys: (tokens[i][10]),
                    sells: (tokens[i][11])
            });
        }
        return walletTokens;
    }

    function parseTokenAnalyzerWallets(wallets) {
        let tokenWallets = [];
        for(let i in wallets) {
            tokenWallets.push({
                indicator: getTypeOfIndicatorByValue(TOKEN_PNL, wallets[i][4]),
                shortAddress: getAddress(wallets[i][0].toLowerCase()),
                address:wallets[i][0].toLowerCase(),
                bought: floatNumToString(wallets[i][1]),
                sold: floatNumToString(wallets[i][2]),
                profit: floatNumToString(wallets[i][3]),
                pnl: floatNumToString(wallets[i][4]),
                firstTx: formatDate(wallets[i][5]),//timeConverter(wallets[i][5]),
                lastTx: formatDate(wallets[i][6]),
                tradeTime: getTradeTime(wallets[i][7]),
                buys: floatNumToString(wallets[i][8]),
                sells: floatNumToString(wallets[i][9])
            });
        }
        return tokenWallets;
    }

    function parseCheckWalletPortfolio(portfolio) {
        let walletPortfolio = [];
        for(let i in portfolio) {
            walletPortfolio.push({
                symbol: getTokenSymbol(portfolio[i][0]),
                name: getTokenName(portfolio[i][1]),
                indicator: getTypeOfIndicatorByValue(WALLET_PNL, portfolio[i][7]),
                address:portfolio[i][2].toLowerCase(),
                balance: (floatNumToStringWithSym(portfolio[i][3])) + " " +getShortTokenSymbol(portfolio[i][0]),
                price: (floatNumToString(portfolio[i][5]))+"$",
                value: (floatNumToString(portfolio[i][6]))+"$",
                change: (floatNumToString(portfolio[i][7]))+"%"
            });
        }
        return walletPortfolio;
    }

    function formatDate(unixTimestamp) {
        if (unixTimestamp === 0) {
            return "—";
        }
        const date = new Date(unixTimestamp * 1000); // Преобразуем секунды в миллисекунды

        let day = date.getDate().toString().padStart(2, '0');
        let month = (date.getMonth() + 1).toString().padStart(2, '0'); // Месяцы индексируются с нуля
        let year = date.getFullYear().toString().slice(-2); // Берем последние две цифры года
        let hours = date.getHours().toString().padStart(2, '0');
        let minutes = date.getMinutes().toString().padStart(2, '0');
        let seconds = date.getSeconds().toString().padStart(2, '0');

        return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    }

    function timeConverter(UNIX_timestamp){
        if (UNIX_timestamp === 0) {
            return "—";
        }
        let a = new Date(UNIX_timestamp * 1000);
        let year = a.getFullYear() - 2000;
        let month = a.getMonth();
        let date = a.getDate();
        let hour = a.getHours();
        let min = a.getMinutes();
        let sec = a.getSeconds();
        return getStrForDateTimeFromNumber(date) + '.' + getStrForDateTimeFromNumber(month) + '.' +
            year + ' ' + getStrForDateTimeFromNumber(hour) + ':' + getStrForDateTimeFromNumber(min) + ':' +
            getStrForDateTimeFromNumber(sec);
    }

    function getStrForDateTimeFromNumber(number){
        if(number < 10) {
            return "0" + number;
        } else {
            return number.toString();
        }
    }

    function getTokenName(name){
        if (name.length > 15) {
            name = name.slice(0, 15)+'...';
            return name;
        } else {
            return name;
        }
    }

    function getTokenSymbol(name){
        if (name.length > 10) {
            name = name.slice(0, 10)+'...';
            return name;
        } else {
            return name;
        }
    }

    function getShortTokenSymbol(name){
        if (name.length > 6) {
            name = name.slice(0, 6)+'...';
            return name;
        } else {
            return name;
        }
    }

    function getAddress(name){
        if (name.length > 12) {
            name = name.slice(0, 7)+'...'+name.slice(name.length - 6, name.length);
            return name;
        } else {
            return name;
        }
    }

    function parseCheckWalletStats(stats){
        let walletStats = [];
        walletStats.push({
            type: WALLET_PROFIT,
            indicator: getTypeOfIndicatorByValue(WALLET_PROFIT, stats["profit"][2]),
            stat: floatNumToString(stats["profit"][2])+"$",
            firstDescription: "Realized: "+floatNumToString(stats["profit"][0])+"$",
            secondDescription: "Unrealized: "+floatNumToString(stats["profit"][1])+"$"
        });
        walletStats.push({
            type: WALLET_PNL,
            indicator: getTypeOfIndicatorByValue(WALLET_PNL, stats["pnl"][2]),
            stat: floatNumToString(stats["pnl"][2])+"%",
            firstDescription: "Realized: "+floatNumToString(stats["pnl"][0])+"%",
            secondDescription: "Unrealized: "+floatNumToString(stats["pnl"][1])+"%"
        });
        walletStats.push({
            type: WALLET_WIN_RATE,
            indicator: getTypeOfIndicatorByValue(WALLET_WIN_RATE, stats["winrate"][2]),
            stat: floatNumToString(stats["winrate"][2])+"%",
            firstDescription: "Win: "+stats["winrate"][0],
            secondDescription: "Lose: "+stats["winrate"][1]
        });
        walletStats.push({
            type: WALLET_TRADES,
            indicator: getTypeOfIndicatorByValue(WALLET_TRADES, stats["trades"][2]),
            stat: floatNumToString(stats["trades"][2]),
            firstDescription: "Buys: "+floatNumToString(stats["trades"][0]),
            secondDescription: "Sells: "+floatNumToString(stats["trades"][1])
        });
        walletStats.push({
            type: WALLET_AVERAGE_TRADE_TIME,
            indicator: getTypeOfIndicatorByValue(WALLET_AVERAGE_TRADE_TIME, stats["average_trade_time"][2]),
            stat: getTradeTime(stats["average_trade_time"][2]),
            firstDescription: "Min: "+getTradeTime(stats["average_trade_time"][0]),
            secondDescription: "Max: "+getTradeTime(stats["average_trade_time"][1])
        });
        walletStats.push({
            type: WALLET_AVERAGE_BUY_VOLUME,
            indicator: getTypeOfIndicatorByValue(WALLET_AVERAGE_BUY_VOLUME, stats["average_buy_volume"][2]),
            stat: floatNumToString(stats["average_buy_volume"][2])+"$",
            firstDescription: "Min: "+floatNumToString(stats["average_buy_volume"][0])+"$",
            secondDescription: "Max: "+floatNumToString(stats["average_buy_volume"][1])+"$"
        });
        return walletStats;
    }

    function parseTokenAnalyzerStats(stats){
        let tokenStats = [];
        tokenStats.push({
            type: TOKEN_NAME,
            indicator: getTypeOfIndicatorByValue(TOKEN_NAME, stats["token"][0]),
            stat: getStrFromTokenSymbol(stats["token"][0]),
            firstDescription: getStrFromTokenName(stats["token"][1]),
            secondDescription: ""
        });
        tokenStats.push({
            type: TOKEN_WALLETS,
            indicator: getTypeOfIndicatorByValue(TOKEN_WALLETS, stats["wallets"][2]),
            stat: floatNumToString(stats["wallets"][2]),
            firstDescription: "Profitable: "+floatNumToString(stats["wallets"][0]),
            secondDescription: "Unprofitable: "+floatNumToString(stats["wallets"][1])
        });
        tokenStats.push({
            type: TOKEN_TRANSACTIONS,
            indicator: getTypeOfIndicatorByValue(TOKEN_TRANSACTIONS, stats["transactions"][2]),
            stat: floatNumToString(stats["transactions"][2]),
            firstDescription: "First Tx: "+formatDate(stats["transactions"][0]),
            secondDescription: "Last Tx: "+formatDate(stats["transactions"][1])
        });
        tokenStats.push({
            type: TOKEN_TRADES,
            indicator: getTypeOfIndicatorByValue(TOKEN_TRADES, stats["trades"][2]),
            stat: floatNumToString(stats["trades"][2]),
            firstDescription: "Buys: "+floatNumToString(stats["trades"][0]),
            secondDescription: "Sells: "+floatNumToString(stats["trades"][1])
        });
        tokenStats.push({
            type: TOKEN_AVERAGE_TRADE_TIME,
            indicator: getTypeOfIndicatorByValue(TOKEN_AVERAGE_TRADE_TIME, stats["average_trade_time"][2]),
            stat: getTradeTime(stats["average_trade_time"][2]),
            firstDescription: "Min: "+getTradeTime(stats["average_trade_time"][0]),
            secondDescription: "Max: "+getTradeTime(stats["average_trade_time"][1])
        });
        tokenStats.push({
            type: TOKEN_AVERAGE_BUY_VOLUME,
            indicator: getTypeOfIndicatorByValue(TOKEN_AVERAGE_BUY_VOLUME, stats["average_buy_volume"][2]),
            stat: floatNumToString(stats["average_buy_volume"][2])+"$",
            firstDescription: "Min: "+floatNumToString(stats["average_buy_volume"][0])+"$",
            secondDescription: "Max: "+floatNumToString(stats["average_buy_volume"][1])+"$"
        });
        return tokenStats;
    }

    function getStrFromTokenName(tokenName) {
        if (tokenName.length > 15) {
            tokenName = tokenName.slice(0, 15) + '...';
        }
        return tokenName;
    }

    function getStrFromTokenSymbol(tokenSymbol) {
        if (tokenSymbol.length > 10) {
            tokenSymbol = tokenSymbol.slice(0, 10) + '...';
        }
        return tokenSymbol;
    }

    function floatNumToString(number) {
        if (number === null) {
            return  0;
        }
        let numAbs = Math.abs(number);
        if(numAbs === 0) {
            return 0;
        }
        if(numAbs >= 1.0 && numAbs < 10000000000) {
            return number.toLocaleString('fr-FR', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }).replace(',', '.');
        } else if (numAbs >= 10000000000) {
            return Math.round(number).toExponential(5);
        } else if (numAbs === 0) {
            return (0.0).toFixed(1);
        } else if (numAbs < 0.00001) {
            return number.toExponential(5);
        } else if (numAbs >= 0.00001 && numAbs < 1.0) {
            return number.toFixed(5);
        } else {
            return number;
        }
    }

    function floatNumToStringPrice(number) {
        if (number === null) {
            return  0;
        }
        let numAbs = Math.abs(number);
        if(numAbs >= 1.0 && numAbs < 10000000000) {
            return number.toLocaleString('fr-FR', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }).replace(',', '.')+"$";
        } else if (numAbs >= 10000000000) {
            return Math.round(number).toExponential(5)+"$";
        } else if (numAbs === 0) {
            return "—";
        } else if (numAbs < 0.000001) {
            return number.toExponential(5)+"$";
        } else {
            return number+"$";
        }
    }

    function floatNumToStringWithSym(number) {
        let numAbs = Math.abs(number);
        if (numAbs === 0) {
            return 0;
        }
        if(numAbs >= 1.0 && numAbs < 1000000) {
            return number.toLocaleString('fr-FR', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }).replace(',', '.');
        } else if (numAbs >= 1000000 && numAbs < 1000000) {
            return Math.trunc(numAbs / 1000.0)+"K";
        } else if (numAbs >= 10000000 && numAbs < 1000000000) {
            return Math.trunc(numAbs / 1000000.0)+"M";
        } else if (numAbs >= 10000000000 && numAbs < 1000000000000) {
            return Math.trunc(numAbs / 10000000000.0)+"B";
        } else if (numAbs >= 1000000000000 && numAbs < 1000000000000000) {
            return Math.trunc(numAbs / 1000000000000.0)+"T";
        } else if (numAbs >= 1000000000000000) {
            return Math.round(number).toExponential(5);
        } else if (numAbs < 0.000001) {
            return number.toExponential(5);
        } else {
            return number;
        }
    }

    function getTradeTime(value) {

        if (value === 0) {
            return "—";
        }

        let days = Math.trunc(value / 86400.0);
        let hours = Math.trunc((value - days * 86400.0) / 3600);
        let minutes = Math.trunc((value - days * 86400.0 - hours * 3600.0) / 60);
        let seconds = (value - days * 86400.0 - hours * 3600.0 - minutes * 60.0).toFixed(0);
        let days_str = (days === 0) ? "" : (days.toString()+"d"+" ");
        let hours_str = (hours === 0) ? "" : (hours.toString()+"h"+" ");
        let minutes_str = (minutes === 0) ? "" : (minutes.toString()+"m"+" ");
        return days_str + hours_str + minutes_str + seconds + "s";
    }

    function getTypeOfIndicatorByValue(type, value){
        let indicator = YELLOW;
        if(type === WALLET_PROFIT) {
            if(value < -1000.0) {
                indicator = RED;
            } else if (-1000.0 <= value && value < -100.0) {
                indicator = ORANGE;
            } else if (-100.0 <= value && value < 100.0) {
                indicator = YELLOW;
            } else if (1000.0 > value && value >= 100.0) {
                indicator = EMERALD;
            } else if (value >= 1000.0) {
                indicator = GREEN;
            }
        } else if(type === WALLET_PNL || type === TOKEN_PNL) {
            if(value < -50.0) {
                indicator = RED;
            } else if (-50.0 <= value && value < -10.0) {
                indicator = ORANGE;
            } else if (-10.0 <= value && value < 10.0) {
                indicator = YELLOW;
            } else if (100.0 > value && value >= 10.0) {
                indicator = EMERALD;
            } else if (value >= 100.0) {
                indicator = GREEN;
            }
        } else if(type === WALLET_WIN_RATE) {
            if(value < 20.0) {
                indicator = RED;
            } else if (20.0 <= value && value < 40.0) {
                indicator = ORANGE;
            } else if (40.0 <= value && value < 60.0) {
                indicator = YELLOW;
            } else if (80.0 > value && value >= 60.0) {
                indicator = EMERALD;
            } else if (value >= 80.0) {
                indicator = GREEN;
            }
        } else if(type === WALLET_TRADES) {
            if(value < 5.0) {
                indicator = RED;
            } else if (5.0 <= value && value < 10.0) {
                indicator = ORANGE;
            } else if (10.0 <= value && value < 20.0) {
                indicator = YELLOW;
            } else if (40.0 > value && value >= 20.0) {
                indicator = EMERALD;
            } else if (value >= 40.0) {
                indicator = GREEN;
            }
        } else if(type === WALLET_AVERAGE_TRADE_TIME || type === TOKEN_AVERAGE_TRADE_TIME) {
            if(value < 60.0) {
                indicator = RED;
            } else if (60.0 <= value && value < 120.0) {
                indicator = ORANGE;
            } else if (120.0 <= value && value < 600.0) {
                indicator = YELLOW;
            } else if (3600.0 > value && value >= 600.0) {
                indicator = EMERALD;
            } else if (value >= 3600.0) {
                indicator = GREEN;
            }
        } else if(type === WALLET_AVERAGE_BUY_VOLUME || type === TOKEN_AVERAGE_BUY_VOLUME) {
            if(value < 50.0) {
                indicator = RED;
            } else if (50.0 <= value && value < 100.0) {
                indicator = ORANGE;
            } else if (100.0 <= value && value < 200.0) {
                indicator = YELLOW;
            } else if (300.0 > value && value >= 200.0) {
                indicator = EMERALD;
            } else if (value >= 300.0) {
                indicator = GREEN;
            }
        } else if(type === TOKEN_WALLETS) {
            if(value < 20.0) {
                indicator = RED;
            } else if (20.0 <= value && value < 50.0) {
                indicator = ORANGE;
            } else if (50.0 <= value && value < 100.0) {
                indicator = YELLOW;
            } else if (200.0 > value && value >= 100.0) {
                indicator = EMERALD;
            } else if (value >= 200.0) {
                indicator = GREEN;
            }
        } else if(type === TOKEN_TRANSACTIONS) {
            if(value < 20.0) {
                indicator = RED;
            } else if (20.0 <= value && value < 50.0) {
                indicator = ORANGE;
            } else if (50.0 <= value && value < 100.0) {
                indicator = YELLOW;
            } else if (200.0 > value && value >= 100.0) {
                indicator = EMERALD;
            } else if (value >= 200.0) {
                indicator = GREEN;
            }
        } else if(type === TOKEN_TRADES) {
            if(value < 20.0) {
                indicator = RED;
            } else if (20.0 <= value && value < 50.0) {
                indicator = ORANGE;
            } else if (50.0 <= value && value < 100.0) {
                indicator = YELLOW;
            } else if (200.0 > value && value >= 100.0) {
                indicator = EMERALD;
            } else if (value >= 200.0) {
                indicator = GREEN;
            }
        }

        return indicator;
    }


    return {
        reqCheckWallet: reqCheckWallet,
        parseCheckWalletResult: parseCheckWalletResult,
        reqTokenAnalyzer: reqTokenAnalyzer,
        reqAuth: reqAuth,
        checkTonTx: checkTonTx,
        getUserDataFromDb: getUserDataFromDb,
        reqCheckWalletOrSetTask: reqCheckWalletOrSetTask,
        reqTokenAnalyzerOrSetTask: reqTokenAnalyzerOrSetTask,
        parseTokenAnalyzerResult: parseTokenAnalyzerResult
    }
}
